<template>
  <div>
    <!-- <ul> -->
    <!-- <li @click="rectangle">矩形面积</li>
      <li @click="polygon">多边形面积</li>
      <li @click="circle">圆形面积</li> -->
    <!-- </ul> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

var measurementGeometry = {};
var measurementGeometryNum = 0;
let drawnItems = new L.FeatureGroup();
export default {
  data() {
    return { drawControl: null, showMeasure: false, circleMarker: null };
  },

  methods: {
    ...mapMutations({
      changeOpenRanging: "swichLayer/changeOpenRanging",
    }),
    measure() {
      // var measureAction = new L.MeasureAction(map, {
      //   model: "distance", // 'area' or 'distance', default is 'distance'
      // });
      // // measureAction.setModel('area');
      // measureAction.enable();

      this.showMeasure = !this.showMeasure;
      if (this.showMeasure) {
        this.changeOpenRanging(true);
        ourMap.points = [];
        ourMap.MarkerPoints = [];

        this.circleMarker = L.circleMarker([0, 0], {
          radius: 5,
          color: "#90ee90",
          opacity: 1,
        }).addTo(map);

        map.on("mousemove", (e) => {
          this.circleMarker.setLatLng([e.latlng.lat, e.latlng.lng]);
        });
      } else {
        this.changeOpenRanging(false);
        ourMap.points = [];
        this.circleMarker.removeFrom(map);
      }
    },
    rectangle() {
      new L.Draw.Rectangle(map, this.drawControl.options.draw.circle).enable();
    },
    polygon() {
      new L.Draw.Polygon(map, this.drawControl.options.draw.circle).enable();
    },
    circle() {
      new L.Draw.Circle(map, this.drawControl.options.draw.circle).enable();
    },
    initDrawControl() {
      map.addLayer(drawnItems);
      // Set the title to show on the polygon button
      L.drawLocal.draw.toolbar.buttons.polygon = "Draw a sexy polygon!";
      this.drawControl = new L.Control.Draw({
        position: "bottomleft",
        draw: {
          rectangle: {
            shapeOptions: {
              color: "#ffab0f",
              weight: 3,
            },
          },
          circle: {
            shapeOptions: {
              color: "#ffab0f",
              weight: 3,
            },
          },
          polygon: {
            shapeOptions: {
              color: "#ffab0f",
              weight: 3,
            },
          },
        },
        edit: {
          featureGroup: drawnItems,
          remove: true,
        },
      });
      // map.addControl(this.drawControl);

      map.on(L.Draw.Event.CREATED, (event) => {
        var layer = event.layer;
        var area = 0;
        var length = 0;
        var centerPoint = {};
        if (event.layerType == "rectangle") {
          var coordinates = [];
          layer._latlngs[0].forEach(function (item, index) {
            coordinates.push([item.lng, item.lat]);
          });
          coordinates.push([
            layer._latlngs[0][0].lng,
            layer._latlngs[0][0].lat,
          ]);

          var polygon = this.$turf.polygon([coordinates]);
          area = this.$turf.area(polygon).toFixed(2);
          var polygonLine = this.$turf.lineString(coordinates);
          length = this.$turf.length(polygonLine).toFixed(2);
          var centeroid = this.$turf.centroid(polygon);
          centerPoint = {
            lng: centeroid.geometry.coordinates[0],
            lat: centeroid.geometry.coordinates[1],
          };
        } else if (event.layerType == "circle") {
          area = (Math.PI * layer._mRadius * layer._mRadius).toFixed(2);
          length = ((2 * Math.PI * layer._mRadius) / 1000).toFixed(2);
          centerPoint = layer._latlng;
        } else if (event.layerType == "polygon") {
          var coordinates = [];
          layer._latlngs[0].forEach(function (item, index) {
            coordinates.push([item.lng, item.lat]);
          });
          coordinates.push([
            layer._latlngs[0][0].lng,
            layer._latlngs[0][0].lat,
          ]);
          var polygon = this.$turf.polygon([coordinates]);
          area = this.$turf.area(polygon).toFixed(2);
          var polygonLine = this.$turf.lineString(coordinates);
          length = this.$turf.length(polygonLine).toFixed(2);
          var centeroid = this.$turf.centroid(polygon);
          centerPoint = {
            lng: centeroid.geometry.coordinates[0],
            lat: centeroid.geometry.coordinates[1],
          };
          console.log(centerPoint);
        }
        drawnItems.addLayer(layer);
        measurementGeometry[measurementGeometryNum] = layer;
        var popupContent =
          '<div class="">' +
          "<h3>测量结果</h3> " +
          "<p>面积：" +
          area +
          " Sq Meters</p>" +
          "<p>周长：" +
          length +
          " Kilometers</p> " +
          '<ul style="    margin: 12px 0 0;\n' +
          "    padding: 10px 0 0;\n" +
          "    border-top: 1px solid #ddd;\n" +
          "    text-align: right;\n" +
          "    list-style: none;\n" +
          '    list-style-image: none;"> ' +
          '<li><a href="#" onclick="clearMeasureResult(' +
          measurementGeometryNum +
          ')" class="js-deletemarkup deletemarkup">清除</a></li> ' +
          "</ul> " +
          "</div>";
        // layer.on("click", function (e) {
        //   L.popup({ minWidth: 150 })
        //     .setLatLng([centerPoint.lat, centerPoint.lng])
        //     .setContent(popupContent)
        //     .openOn(map);
        // });
        layer.popup = L.popup({
          minWidth: 150,
          autoClose: false,
          closeButton: false,
          closeOnClick: false,
        })
          .setLatLng([centerPoint.lat, centerPoint.lng])
          .setContent(popupContent);
        measurementGeometryNum++;
        setTimeout(function () {
          layer.popup.openOn(map);
        }, 500);
      });
    },
  },
  mounted() {
    this.initDrawControl();
    window.clearMeasureResult = (geometryIndex) => {
      measurementGeometry[geometryIndex].popup.remove();
      drawnItems.removeLayer(measurementGeometry[geometryIndex]);
    };
  },
};
</script>

<style lang="less" scoped>
li {
  margin: 5px 0;
}

/deep/ .leaflet-cursor-pointer {
  cursor: pointer;

}
</style>